import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatTableDataSource } from '@angular/material/table';


@Component({
  selector: 'app-cpp-sra-existing-order',
  templateUrl: './cpp-sra-existing-order.component.html',
  styleUrls: ['./cpp-sra-existing-order.component.scss']
})

export class CppSraExistingOrderComponent implements OnInit {
  exisitingCols: string[] = ['returnRequestID', 'customerPO', 'shipToLocation', 'shipToNumber', 'deliverToLocation', 'deliverToNumber'];
  exisitingRecordsDataSource: MatTableDataSource<any>;
  selectedRow: any;

  constructor(public dialogRef: MatDialogRef<CppSraExistingOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public sraExisitingRecords: any) {

  }

  // ngOnInit
  ngOnInit() {
    const recordsArray = Array.isArray(this.sraExisitingRecords?.sraExisitingRecords)
      ? this.sraExisitingRecords.sraExisitingRecords
      : [];

    this.exisitingRecordsDataSource = new MatTableDataSource(recordsArray);
  }

  selectRow(row: any): void {
    this.selectedRow = row;
  }


  onYesClick(): void {
    this.dialogRef.close(this.selectedRow.requestID);
  }

  onNoClick(): void {
    this.dialogRef.close(0);
  }
}
